import script from "./profilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./profilePage.vue?vue&type=script&setup=true&lang=ts"

import "./profilePage.vue?vue&type=style&index=0&id=71ea99b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ea99b4"]])

export default __exports__